@if (data && funktionen) {
  <table class="hover-focus">
    <thead>
      <tr>
        <td colspan="2" rowspan="2" class="no-border"></td>
        <td colspan="8" class="header header-horizontal bold centered border-bold-left border-bold-right border-bold-top border-bold-bottom" translate>
          m1.cockpit-kontrolle.card.currentCodes.table.bkn
        </td>
      </tr>
      <tr>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >1</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >2</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >3</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >4</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >5</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >6</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-bottom" >7</td>
        <td class="subheader subheader-horizontal centered border-bold-left border-bold-right border-bold-bottom" >8</td>
      </tr>
    </thead>
    <tbody>
      @for (bst of data | keyvalue; track bst) {
        <tr>
          @if (bst.key == 'BST_1') {
            <td rowspan="5" class="header header-vertical bold centered border-bold-left border-bold-right border-bold-top border-bold-bottom" style="writing-mode: tb-rl;transform: rotate(180deg);" translate>
              m1.cockpit-kontrolle.card.currentCodes.table.bst
            </td>
          }
          <td class="subheader-vertical centered border-bold-left border-bold-top border-bold-bottom border-bold-right">{{ bst.key.split('_')[1] }}</td>
          @for (bkn of bst.value | keyvalue; track bkn) {
            <td class="align-bottom">
              @if (bkn.value) {
                @for (funktion of bkn.value.funktionen; track funktion) {
                  <div class="funktionen" [ngClass]="{'nurFrauen': funktion.nurFrauen,'nurMaenner': funktion.nurMaenner}">
                    {{ getFunktionName(funktion.funktionsID) }} ({{funktion.anzahlFrauen}}{{'i18n.common.f' | translate}}, {{funktion.anzahlMaenner}}{{'i18n.common.m' | translate}})&nbsp;
                  </div>
                }
                <div>&nbsp;</div>
                <div class="italic">{{'i18n.common.min' | translate}}: {{bkn.value.min | numberFormat: crtLocale }}.-, {{'i18n.common.max' | translate}}: {{bkn.value.max | numberFormat: crtLocale }}.-&nbsp;</div>
                <div class="italic">{{'i18n.common.mittelwert' | translate}}: {{bkn.value.mittelwert | numberFormat: crtLocale }}.-</div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <td colspan="10" class="hint" translate>
          m1.cockpit-kontrolle.card.currentCodes.table.footer
        </td>
      </tr>
    </tfoot>
  </table>
}
